import PropTypes from 'prop-types'
import {
  StyledFooterContainer,
  StyledToolTip,
  StyledFormControl,
  StyledOutlinedInput,
  FlexCenterBox,
  StyledStopActionButton,
  StyledStopIcon,
  StyledIconButton,
  StyledSendIcon
} from '../ChatbotStyles'

const ChatInput = ({
  showFullScreen,
  showDragbar,
  chatFooterContainerRef,
  messageInputRef,
  setDisableSendButton,
  handleKeydown,
  isRequestActive,
  handleCancelRequest,
  disableSendButton,
  showLoader,
  sendButtonRef,
  handleSend
}) => {
  return (
    <StyledFooterContainer showFullScreen={showFullScreen && !showDragbar} ref={chatFooterContainerRef}>
      <StyledFormControl>
        <StyledOutlinedInput
          inputRef={messageInputRef}
          placeholder='Ask a question'
          aria-label='Ask a question'
          disableUnderline={true}
          minRows={1}
          maxRows={3}
          multiline
          onChange={(event) => {
            setDisableSendButton(event.target.value?.trim() === '')
          }}
          onKeyDown={handleKeydown}
          endAdornment={
            <FlexCenterBox>
              {isRequestActive ? (
                <StyledToolTip title='Stop Generation'>
                  <StyledStopActionButton
                    onClick={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      handleCancelRequest()
                    }}
                    onMouseDown={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }}
                  >
                    <StyledStopIcon />
                  </StyledStopActionButton>
                </StyledToolTip>
              ) : (
                <StyledToolTip title={disableSendButton || showLoader ? '' : 'Send'}>
                  <StyledIconButton
                    sendButton={true}
                    ref={sendButtonRef}
                    variant='outlined'
                    onClick={handleSend}
                    disabled={disableSendButton || showLoader}
                  >
                    <StyledSendIcon />
                  </StyledIconButton>
                </StyledToolTip>
              )}
            </FlexCenterBox>
          }
        />
      </StyledFormControl>
    </StyledFooterContainer>
  )
}

ChatInput.propTypes = {
  showFullScreen: PropTypes.bool.isRequired,
  showDragbar: PropTypes.bool.isRequired,
  chatFooterContainerRef: PropTypes.object.isRequired,
  messageInputRef: PropTypes.object.isRequired,
  setDisableSendButton: PropTypes.func.isRequired,
  handleKeydown: PropTypes.func.isRequired,
  isRequestActive: PropTypes.bool.isRequired,
  handleCancelRequest: PropTypes.func.isRequired,
  disableSendButton: PropTypes.bool.isRequired,
  showLoader: PropTypes.bool.isRequired,
  sendButtonRef: PropTypes.object.isRequired,
  handleSend: PropTypes.func.isRequired
}

export default ChatInput

/*
CHATBOT INPUT COMPONENT

KEY FUNCTIONS:
- handleSend: Processes and submits user message
- handleCancelRequest: Stops active streaming requests
- handleKeydown: Manages keyboard shortcuts
- setDisableSendButton: Controls send button state based on input

FEATURES:
- Auto-resize text area (1-3 rows)
- Disabled states during loading
- Tooltips for button actions
- Responsive layout for fullscreen mode
*/
